import { createSelector } from 'reselect'
import {
  noBackButtonList,
} from 'utils/LayoutUtils';

export const getCurrentStep = (state) => state.currentStep;


export const getShowBack = createSelector(
  getCurrentStep,
  (currentStep) =>
    !noBackButtonList.includes(currentStep)
);